import React  from 'react';
import './Alphabet.css';
import Button from '../Button/Button';
import Text from '../Text/Text';

const Alphabet = (props) => {
     const imgesLetter = props.curAlphabet.map((items, index) =>
        <div key={index} className={(items.color === '1') ? 'PlaceLetter glasnyi' : ((items.color === '2') ? 'PlaceLetter soglasnyi' : 'PlaceLetter')} onClick={() => props.onClick('newLetter', items.letter,items.id)} > {items.letter} </div>
    );

    return (
        <div>
            <div className='bgAlphabet' ></div>
            <Text className='AlphabetName' value={props.textGame.AlphabetName[props.lang]} />

            <div className= 'boxAlphabet'>
                {imgesLetter}    
            </div>
            <Text className='GameInfo' value={props.textGame.GameInfo[props.lang]} />
            <Button className='beginA' onClick={() => props.onClick('beginA')} value={props.textGame.Continue[props.lang]} />
        </div>
    );
};

export default Alphabet;